module.exports = __webpack_public_path__ + "static/media/text2.b8dcb642.png";